import React from 'react';
import s from './MobileFeatures.scss';
import { useTranslation, Trans } from '@wix/wix-i18n-config';
import translationObject from '../../../assets/locales/messages_en.json';
import Check from '../../../icons/dist/components/check';
import X from '../../../icons/dist/components/x';
import { createArrayOfElements } from './MobileFeatureHelper';

import { PRODUCT } from '../mobile-constant';
import classNames from 'classnames';
import { getProductLimitationByIndex } from '../../../services/features-services';
import { useExperiments } from '@wix/wix-experiments-react';

interface MobileFeaturesProps {
  selectedProductIndex: number;
}

const MOBILE_FEATURES = 'mobile.feature.element';
const MOBILE_FEATURES_UNCHECK = 'mobile.feature.uncheck';
const PRODUCT_CODES = ['unlimited', 'pro', 'basic', 'limited'];

export const MobileFeatures: React.FunctionComponent<MobileFeaturesProps> = (
  props: MobileFeaturesProps,
) => {
  const productCode = PRODUCT_CODES[props.selectedProductIndex];
  const { t } = useTranslation();
  const { experiments } = useExperiments();

  const shouldHideVideoMaker = experiments.enabled(
    'specs.ascend.PackagePickerRemoveVideoMaker',
  );
  const showAscendMonetizationChanges = experiments.enabled(
    'specs.so.app.NewAscendMonetization',
  );

  const activeExperiments = {
    showAscendMonetizationChanges,
  };

  const arrayOfElements = createArrayOfElements(
    shouldHideVideoMaker,
    showAscendMonetizationChanges,
  );

  const arrayOfRelevant = arrayOfElements.filter((_obj) =>
    _obj[0].includes(`${MOBILE_FEATURES}.${productCode}.`),
  );

  const selectedClassName = (index: number, isFeatureUnchecked: boolean) => ({
    [s.uncheck]: isFeatureUnchecked,
    [s.isProductLimited]: index === PRODUCT.FREE,
    [s.isProductBasic]: index === PRODUCT.BASIC,
    [s.isProductPro]: index === PRODUCT.PRO,
    [s.isProductUnlimited]: index === PRODUCT.UNLIMITED,
  });

  return (
    <div className={s.strip} data-hook="mobile-features">
      <div
        className={s.title}
        data-hook={`mobile-features-title-${props.selectedProductIndex}`}
      >
        {t(`mobile.feature.title.${productCode}`)}
      </div>
      {arrayOfRelevant.map((feature, index) => {
        const featureKey = feature[0];
        const uncheckKey = featureKey.replace(
          `${MOBILE_FEATURES}.${productCode}`,
          MOBILE_FEATURES_UNCHECK,
        );
        const uncheckElement = arrayOfElements.find((_) => _[0] === uncheckKey);
        const isFeatureUncheck =
          !!uncheckElement && uncheckElement[1].includes(productCode);

        return (
          <div
            className={s.featureBox}
            key={index}
            data-hook={`mobile-feature-${props.selectedProductIndex}`}
          >
            <div
              className={classNames(
                s.checkUncheck,
                selectedClassName(props.selectedProductIndex, isFeatureUncheck),
              )}
            >
              {isFeatureUncheck ? <X size="1.86vw" /> : <Check size="3vw" />}
            </div>
            <div className={s.featureDesc}>
              <Trans components={{ bold: <span className={s.bold} /> }}>
                {t(
                  featureKey,
                  getProductLimitationByIndex(
                    props.selectedProductIndex,
                    t('features.UNLIMITED.string'),
                    activeExperiments,
                  ),
                )}
              </Trans>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MobileFeatures;
